import React, { useState } from 'react';
import { CountLabel, Spacer } from 'src/common';
import { RowInvite } from 'src/components/orgRows';
import { useAcceptInviteMutation, useRejectInviteMutation } from 'src/graphql/_generated';
import { useAuth } from 'src/state/auth';
import styled from 'styled-components';
import { showSuccessToast, toastMessages } from 'src/components/Toast';

const Div = styled.div`
  .orgs-list {
    display: grid;
    grid-gap: 10px;
  }
`;

interface InvitesProps {
  onSuccess: () => void;
}

export const Invites: React.FC<InvitesProps> = ({ onSuccess }) => {
  const [loadingInviteIds, setLoadingInviteIds] = useState<string[]>([]);
  const { profile } = useAuth();

  const [acceptInvite] = useAcceptInviteMutation();
  const [rejectInvite] = useRejectInviteMutation();

  const invites = profile?.user.invites || [];

  return (
    <Div>
      {invites.length > 0 && (
        <>
          <Spacer $px={30} />
          <CountLabel label="invite" length={invites.length} />
          <Spacer $px={5} />
          <div className="orgs-list">
            {invites.map((el) => (
              <RowInvite
                key={el.id}
                id={el.id!}
                name={el.workspaceName!}
                organisationName={el.organisationName!}
                orgUnitType={el.orgUnitType || ''}
                img={null}
                onAccept={async () => {
                  setLoadingInviteIds((prev) => [...prev, el.id!]);
                  await acceptInvite({
                    variables: { inviteId: el.id! },
                  });
                  onSuccess();
                  showSuccessToast(toastMessages.workspace.inviteAccepted);
                  setLoadingInviteIds((prev) => prev.filter((s) => s !== el.id));
                }}
                onReject={async () => {
                  setLoadingInviteIds((prev) => [...prev, el.id!]);
                  await rejectInvite({
                    variables: { inviteId: el.id! },
                  });
                  onSuccess();
                  showSuccessToast(toastMessages.user.requestRejected);
                  setLoadingInviteIds((prev) => prev.filter((s) => s !== el.id));
                }}
                isLoading={loadingInviteIds.includes(el.id!)}
              />
            ))}
          </div>
        </>
      )}
    </Div>
  );
};
